const raffle = () => {
    if (document.querySelector('.raffle')) {
        let parentElem = document.querySelector('.raffle')
        let openbtn = parentElem.querySelector('.raffle__btn')

        let fileInput = parentElem.querySelector('[type="file"]')
        let inpWrap = parentElem.querySelector('.raffle__list-file')
        let fileArr = []

        let parList = parentElem.querySelector('.raffle__list-file')

        openbtn.onclick = () => {
            openbtn.setAttribute('style', 'opacity: 0; transition: .5s all; max-height: 0; min-height: unset; margin: 0; width: 0;')
        }

        fileInput.onchange = onChange

        fileInput.addEventListener('change', () => {

        })

        function onChange() {
            [...fileInput.files].forEach(file => {
                if (file.size <= 10 * 1024 * 1024) {
                    const reader = new FileReader;
                    reader.addEventListener('loadend', () => {
                        const item = document.createElement('li');
                        const image = new Image;
                        image.src = `data:${file.type};base64,${btoa(reader.result)}`;
                        const remove = document.createElement('a');
                        remove.innerHTML = '⊗';
                        const fileItem = {
                            name: file.name,
                            modified: file.lastModified,
                            size: file.size,
                            data: reader.result
                        };
                        fileArr.push(fileItem);
                        remove.addEventListener('click', () => {
                            fileArr.splice(fileArr.indexOf(fileItem), 1);
                            item.classList.add('removing');
                            setTimeout(() => item.remove(), 100);
                            if (inpWrap.querySelectorAll('.raffle__list-item').length <= 1) {
                                fileInput.value = '';
                            } else {
                            }
                        });
                        item.appendChild(remove);
                        item.appendChild(image);
                        inpWrap.appendChild(item);
                        item.classList.add('raffle__list-item')
                        image.classList.add('item-img')
                    });
                    reader.readAsBinaryString(file);
                } else {
                    fileInput.type = ''
                    fileInput.type = 'file'
                }
            });
            if (fileInput.files.length >= 4) {
                setTimeout(() => { parList.innerHTML = '' }, 200)
                fileInput.type = ''
                fileInput.type = 'file'
                parList.closest('.Input').querySelector('.input-validation__message').textContent = 'Выбрать можно не более трех файлов'
                parList.closest('.Input').querySelector('.input-validation__message').classList.add('input-validation--invalid')
            } else {
                parList.closest('.Input').querySelector('.input-validation__message').classList.remove('input-validation--invalid')
                parList.closest('.Input').querySelector('.input-validation__message').textContent = ''
            }
        }


    }
}

$(document).on('mousedown', '[data-type-raffle]', function (e) {
    
    // function preloaderClose() {
    //     $.fancybox.close({
    //         src: '#popup-preloader-coupon',
    //         toolbar: false,
    //     });
    // }
    // function preloaderShow() {
    //     $.fancybox.open({
    //         src: '#popup-preloader-coupon',
    //         toolbar: false,
    //     });
    // }
    // let popup = document.querySelector('.raffle').querySelector('.popup-success-res');
    // let popupBtn = $(this).closest('form').find('[data-fancybox-window]');
    // var $this = $(this);
    // var $form = $this.closest('form');
    // var formUrl = '/ajax/coupon/register-coupon.php';
    // let validField = $(this).closest('form').find('.input-validation--valid')
    // var form = document.getElementById('coupon-form');
    // // var params = new FormData(form);
    // let field = $(this).closest('form').find('input:not([type="submit"])')
    // if (validField.length === field.length) {
    //     preloaderShow();
    //     $.ajax({
    //         url: formUrl,
    //         method: 'post',
    //         type: "POST",             // Type of request to be send, called as method
    //         data: new FormData($form.get(0)), // Data sent to server, a set of key/value pairs (i.e. form fields and values)
    //         contentType: false,       // The content type used when sending data to the server.
    //         cache: false,             // To unable request pages to be cached
    //         processData: false,        // To send DOMDocument or non processed data file it is set to false

    //         dataType: 'json',
    //         success: function (response) {
    //             preloaderClose();
    //             popupBtn.trigger('click')
    //             popup.classList.remove('res-error')
    //             popup.classList.add('res-success')
    //             popup.querySelector('[data-title]').textContent = 'Заявка отправлена'
    //             popup.querySelector('[data-text]').textContent = response.successText
    //             var link = document.createElement('a');
    //             document.body.appendChild(link);
    //             link.download = 'coupon.pdf';
    //             link.href = response.link;
    //             link.click();
    //             setTimeout(() => { window.location = 'https://tandoor.ru/' }, 5000)
    //         },
    //         error: function (p1, p2, p3) {

    //         }
    //     });
    // }
    // return false;



    //     let popup = document.querySelector('.raffle').querySelector('.popup-success-res')
    //     let $this = $(this);
    //     let $form = $this.closest('form');
    //     let formUrl = $form.attr('data-action');
    //     let btn = $('[data-download]')
    //     let popupBtn = $(this).closest('form').find('[data-fancybox-window]')
    //     let validField = $(this).closest('form').find('.input-validation--valid')
    //     let field = $(this).closest('form').find('input:not([type="submit"])')
    //     if (validField.length === field.length) {
    //         $.ajax({
    //             url: formUrl,
    //             // url: 'https://jsonplaceholder.typicode.com/posts',
    //             method: 'post',
    //             data: new FormData($form.get(0)),
    //             contentType: false,
    //             cache: false,
    //             processData: false,
    //             dataType: 'json',
    //             success: function (res) {
    //                 if (!res.hasError) {
    //                     $form.find('input, textarea').val('');
    //                     $('.ctrFiles').html('');
    //                 }

    // if (res.status === 'success') {
    //     btn.setAttribute('href', res.link);
    //     btn.setAttribute('download', '');
    //     btn.trigger('click')

    //     popupBtn.trigger('click')
    //     popup.classList.remove('res-error')
    //     popup.classList.add('res-success')
    //     popup.querySelector('[data-title]').textContent = 'Заявка отправлена'
    //     popup.querySelector('[data-text]').textContent = res.successText
    //     setTimeout(() => { window.location = 'https://tandoor.ru/' }, 5000)
    // }
    //             },
    //             error: function (p1, p2, p3) {
    //                 popupBtn.trigger('click')
    //                 popup.classList.add('res-error')
    //                 popup.classList.remove('res-success')
    //                 popup.querySelector('[data-title]').textContent = 'Ошибка'
    //                 popup.querySelector('[data-text]').textContent = res.successText
    //             }
    //         });
    //     }
    //     return false;
});